import { render, staticRenderFns } from "./ScriptsElements.vue?vue&type=template&id=084b1dff&scoped=true&"
import script from "./ScriptsElements.vue?vue&type=script&lang=js&"
export * from "./ScriptsElements.vue?vue&type=script&lang=js&"
import style0 from "./ScriptsElements.vue?vue&type=style&index=0&id=084b1dff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b1dff",
  null
  
)

export default component.exports